export default __webpack_public_path__ + "static/media/3.1e4dcb5f.jpeg";